import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// App custom scheme (cleaner-app `app.json` → expo.scheme = "wiseclean-cleaner").
const APP_SCHEME = 'wiseclean-cleaner';

// ws5 Cleaner apigroup — public availability check (no token needed).
const API_BASE = 'https://api.wiseclean.ee/api:kjtchkL8';

// Store fallback URLs (canonical platform values — see README.md).
const STORE_URL_IOS = 'https://apps.apple.com/app/id6761757045';
const STORE_URL_ANDROID =
    'https://play.google.com/store/apps/details?id=eu.wiseclean.cleaner';

// How long to wait for the app to grab the scheme before bouncing to the store.
const FALLBACK_DELAY_MS = 1500;

const pickStoreUrl = () => {
    const ua = (navigator.userAgent || navigator.vendor || '').toLowerCase();
    if (/android/.test(ua)) return STORE_URL_ANDROID;
    if (/iphone|ipad|ipod/.test(ua)) return STORE_URL_IOS;
    // Desktop / unknown — default to the iOS listing (cleaners are iOS-heavy).
    return STORE_URL_IOS;
};

const OpenOrder = () => {
    const { id } = useParams();
    const [taken, setTaken] = useState(false);

    useEffect(() => {
        if (!id) return undefined;

        let timer;
        let cancelled = false;

        // Bounce into the app + fall back to the store if it isn't installed.
        const proceed = () => {
            window.location.href = `${APP_SCHEME}://order/${encodeURIComponent(id)}`;
            timer = setTimeout(() => {
                window.location.href = pickStoreUrl();
            }, FALLBACK_DELAY_MS);
        };

        // Check availability FIRST: if another cleaner already took the order (or
        // it's gone), show "already taken" and do NOT open the app. On any check
        // failure, fail-open and proceed — a flaky check must never block a
        // legitimate open.
        fetch(`${API_BASE}/orders/${encodeURIComponent(id)}/availability`, {
            headers: { Accept: 'application/json' },
        })
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => {
                if (cancelled) return;
                if (data && data.available === false) {
                    setTaken(true);
                } else {
                    proceed();
                }
            })
            .catch(() => {
                if (!cancelled) proceed();
            });

        return () => {
            cancelled = true;
            if (timer) clearTimeout(timer);
        };
    }, [id]);

    if (taken) {
        return (
            <div style={styles.container}>
                <p style={styles.title}>Заказ уже взят</p>
                <p style={styles.text}>
                    Этот заказ уже взял другой клинер или он больше не доступен.
                </p>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            <p style={styles.text}>Открываем приложение…</p>
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
    },
    title: { fontSize: '20px', fontWeight: 700, color: '#1A1A2E', margin: 0 },
    text: { fontSize: '16px', color: '#555', marginTop: '10px' },
};

export default OpenOrder;
